export const CARS_FORM_MESSAGES = {
    SUCCESS: "Ваше обращение успешно отправлено!",
    ERROR: "Ошибка при отправке формы, попробуйте позже."
};

export const UPLOAD_ERROR_MESSAGE = "Не удалось загрузить изображения";